import { array, number, object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import {
	MAX_80_LENGTH,
	MAX_1000_LENGTH,
} from '@constants/validationMessages';

const fields = {
	title: string()
		.trim()
		.default('')
		.max(MAX_80_LENGTH, getMaxLengthErrMsg('Title', MAX_80_LENGTH))
		.required(validationErrMessages.title),
	description: string()
		.trim()
		.default('')
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Milestone Description', MAX_1000_LENGTH)),
	startDate: number()
		.nullable()
		.required(validationErrMessages.startDate),
	endDate: number()
		.nullable()
		.required(validationErrMessages.endDate),
	assignees: array().nullable(),
};

export const getSchema = (isEditMode?: boolean) => {
	if (isEditMode) {
		return object({
			...fields,
			status: string()
				.nullable()
				.required(validationErrMessages.status),
		});
	}

	return object({
		...fields,
		project: object()
			.nullable()
			.required(validationErrMessages.projectName),
	});
};
